import { usewpdataSelectors } from '../../../lib/wpdataState/selectors';
import { useState } from 'react';
import s from './Button.module.scss';

const Button = ({
  text,
  className = '',
  attribute,
  style,
  isLink = true,
  onClick,
  isLoading: externalIsLoading,
  theme,
  href,
}) => {
  const { Theme: contextTheme, Settings } = usewpdataSelectors();
  const [internalIsLoading, setIsLoading] = useState(false);

  // Use external loading state if provided, otherwise use internal
  const isLoading = externalIsLoading !== undefined ? externalIsLoading : internalIsLoading;

  // Determine the theme - prop takes precedence over context
  const buttonTheme = theme || contextTheme?.button;

  // Determine href - prop takes precedence over Settings.link
  const buttonHref = href || Settings?.link;

  // Function to generate affiliate link with encoded parameters
  const generateAffLink = (baseUrl) => {
    if (!baseUrl || typeof window === 'undefined') return baseUrl;

    try {
      // Validate required globals exist
      if (!window.affiliate || !window.entry_url) {
        console.warn('Affiliate tracking missing required window properties');
        return baseUrl;
      }

      const separator = baseUrl.includes('?') ? '&' : '?';
      return `${baseUrl}${separator}aff=${btoa(window.affiliate)}&entryUrl=${btoa(window.entry_url)}&postId=remote`;
    } catch (error) {
      console.error('Error generating affiliate URL:', error);
      return baseUrl;
    }
  };

  const handleClick = async (e) => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      onClick && (await onClick(e));
    } finally {
      setIsLoading(false);
    }
  };

  const commonProps = {
    'data-cy': attribute,
    style,
    'data-theme': buttonTheme,
    className: `${className} cta ${s.cta}`.trim(),
    disabled: isLoading,
    'data-loading': isLoading,
  };

  if (isLink) {
    return (
      <a {...commonProps} href={buttonHref ? generateAffLink(buttonHref) : undefined}>
        {text}
      </a>
    );
  }

  return (
    <button {...commonProps} onClick={handleClick}>
      {text}
    </button>
  );
};

export default Button;
